import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import venueActions from 'actions/venues/actions'
import LoadingOverlay from 'components/shared/loaders/loading-overlay'
import { FORM_SECTIONS } from 'constants/user-venues'
import VenueForm from './form'

const topBar = {
  edit: {
    title: 'Edit Venue',
    description: `This step requires information from the physical location of your venue. For example, you are company
      ABC with venues in city 1, city 2, and city 3, you will need to input information of your venue in city 1.
      You will then have to add the respective venue contacts and spaces before moving forward.`,
  },
  add: {
    title: 'Add Venue',
    description: `This step requires information from the physical location of your venue. For example, you are company
      ABC with venues in city 1, city 2, and city 3, you will need to input information of your venue in city 1.
      You will then have to add the respective venue contacts and spaces before moving forward.`,
  },
}

const VenueDetails = (props = {}) => {
  const {
    action,
    venueId,
    loading,
    createVenue,
    editVenue,
    setSelectedSection,
    handleSetSuccess,
    venueDetails,
    notification: { type },
    venue_type,
    fetchVenueDetails,
  } = props
  useEffect(() => {
    if (type === 'success') {
      setSelectedSection(FORM_SECTIONS.CONTACTS)
      handleSetSuccess({ [FORM_SECTIONS.DETAILS]: true })
    }
  }, [type])

  const initSchedules = [
    { start_time: '08:00:00', end_time: '18:00:00' },
    { start_time: '08:00:00', end_time: '18:00:00' },
    { start_time: '08:00:00', end_time: '18:00:00' },
    { start_time: '08:00:00', end_time: '18:00:00' },
    { start_time: '08:00:00', end_time: '18:00:00' },
    { start_time: '08:00:00', end_time: '18:00:00' },
    { start_time: '08:00:00', end_time: '18:00:00' },
  ]

  useEffect(() => {
    action === 'edit' && fetchVenueDetails({ id: venueId })
  }, [])

  return (
    <>
      <LoadingOverlay loading={loading}>
        <div className="bg-white py-6 px-10">
          <h1 className="font-bold text-4xl">{topBar[action].title}</h1>
          <small className="text-gray-600">{topBar[action].description}</small>
          {action === 'add' && (
            <VenueForm
              initialValues={{
                venue_type: venue_type ?? 'flexible',
                differentSchedule: true,
                schedulesOpen: initSchedules,
              }}
              onSubmit={(values) => {
                createVenue({ ...values, formName: 'merchant-venue-create-form' })
              }}
              form="merchant-venue-create-form"
            />
          )}
          {action === 'edit' && (
            <VenueForm
              initialValues={{ differentSchedule: true, ...venueDetails }}
              onSubmit={(values) => {
                editVenue({ ...values, formName: 'merchant-venue-edit-form' })
              }}
              form="merchant-venue-edit-form"
            />
          )}
        </div>
      </LoadingOverlay>
    </>
  )
}

VenueDetails.propTypes = {
  createVenue: PropTypes.func,
  loading: PropTypes.bool,
  setSelectedSection: PropTypes.func,
  handleSetSuccess: PropTypes.func,
  action: PropTypes.string,
  venueDetails: PropTypes.object,
  editVenue: PropTypes.func,
  notification: PropTypes.object,
  fetchVenueDetails: PropTypes.func,
  venueId: PropTypes.number,
  venue_type: PropTypes.string,
}

const mapStateToProps = ({ venue, notification }) => ({
  loading: venue.fetching,
  venueDetails: venue.details,
  notification,
})

const mapDispatchToProps = {
  createVenue: venueActions.createVenue,
  editVenue: venueActions.editVenue,
  fetchVenueDetails: venueActions.merchantFetchVenueDetails,
}

export default connect(mapStateToProps, mapDispatchToProps)(VenueDetails)
